import { useEffect, useState } from 'react';
import { jobRoleGateway } from '../../index';
import type { ReferenceCategory } from '../../types';

/** The names of one reference category, for a native select (the controlled lists: levels and the FLSA labels). Loaded once; `null` while loading. */
export function useCategoryNames(category: ReferenceCategory): { names: string[] | null; failed: boolean } {
  const [state, setState] = useState<{ names: string[] | null; failed: boolean }>({ names: null, failed: false });
  useEffect(() => {
    const controller = new AbortController();
    jobRoleGateway
      .listReferenceOptions({ category, take: 100 }, controller.signal)
      .then((list) => {
        if (controller.signal.aborted) return;
        const names: string[] = [];
        for (const g of list.groups) {
          if (g.key === 'Recommended') continue; // a second copy of options that are in the ordered list anyway
          for (const o of g.options) if (!names.includes(o.name)) names.push(o.name);
        }
        setState({ names, failed: false });
      })
      .catch(() => { if (!controller.signal.aborted) setState({ names: null, failed: true }); });
    return () => controller.abort();
  }, [category]);
  return state;
}

